'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _consignment = require('./remote/consignment');

var Consignment = {
    postConsignment: _consignment.ConsignmentRemote.postConsignment
};

exports.default = Consignment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/consignment.js
// module id = /rMq
// module chunks = 57